<template>
    <div id="rbacActiveStatusModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      <div class="modal-content first-modal-content">
        <div class="modal-header deactiveModal-bgcolor">
          <button type="button" class="close" data-toggle="modal" data-target="#rbacActiveStatusModal">&times;</button>
        </div>
        <div class="modal-body desc-text">
          <div class="modal-title">
            <div class="title-text" v-if="roleDetails.is_active">
              <div class="align-lt">Are you sure you would like to deactivate this role?</div>
              <div class="role-name"> {{roleDetails.role_name}}</div>
            </div>
             <div class="title-text" v-else>
              <div class="align-lt">Are you sure you would like to activate this role?</div>
              <div class="role-name pt-10"> {{roleDetails.role_name}}</div>
            </div>
            <div class="col-xs-12 pt-10">
              <div class="col-xs-11" v-if="roleDetails.is_active">
                By deactivating this role, you will lose all data that has been created for this role.
              </div>
              <div class="col-xs-11" v-else>
                By activating this role, you will again access to all saved data that has been previously created.
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer deactiveModal-bgcolor">
          <div class="col-sm-6 col-xs-12 mt-10">
            <button v-if="roleDetails.is_active"
              class="btn btn-block emergo-white-button"
              @click="updateStatus"
            >Yes, deactivate role</button>
            <button v-else
              class="btn btn-block emergo-white-button"
              @click="updateStatus"
            >Yes, activate role</button>
          </div>
          <div class="col-sm-6 col-xs-12 mt-10">
            <button
              class="btn btn-block emergo-blue-button"
              data-toggle="modal"
              data-target="#rbacActiveStatusModal"
            >No, keep role</button>
          </div>
        </div>
      </div>
    </div>
    <loader :loadingStatus="loaderStatus"></loader>
  </div>
</template>
<script>
import $ from 'jquery';
import { updateRoleActiveStatus } from '../../apis/rbac';
import Loader from '../UIComponents/Loader.vue';

export default {
  components: {
    Loader,
  },
  props: ['roleDetails'],
  data() {
    return {
      loaderStatus: false,
      roleId: '',
    };
  },
  mounted() {
    $('#rbacActiveStatusModal').on('shown.bs.modal', () => {
      this.roleId = this.roleDetails.role_id;
    });
  },
  methods: {
    async updateStatus() {
      this.loaderStatus = true;
      await updateRoleActiveStatus(this.roleDetails.role_id, { role_id: this.roleDetails.role_id, active: !this.roleDetails.is_active });
      this.$emit('updateRoleActiveStatus');
      $('#rbacActiveStatusModal').modal('hide');
      this.loaderStatus = false;
    },
  },
};
</script>
<style scoped lang="scss">
.modal-dialog {
  vertical-align: top;
  top: 50px;
}
.modal-header {
	.close {
		background: none;
		opacity: 0.5;
		height: 17px;
		line-height: 17px;
		color: $deep-gray;
		width: 17px;
		border-radius: 20px;
		font-weight: $font-weight-small;
		outline: none;
		font-size: $font-32;
	}
	&.deactiveModal-bgcolor {
		background-color: $deep-white;
		border: 0px;
		border-radius: 10px;
	}
}
.confirm-body {
  padding: 5% 12%;
  margin-bottom: 10%;
  font-family: Roboto;
  font-style: normal;
  font-weight: $font-weight-normal;
  text-align: center;
  color: $dark-black-alpha;
}
.modal-footer.deactiveModal-bgcolor {
  background-color: $deep-white;
  border: 0px;
  border-radius: 10px;
  padding-bottom: 32px;
}
.modal-content.first-modal-content {
	border-radius: 12px;
}
.title-text {
  font-size: 21px;
  color: $black;
  padding-top: 10px;
  font-weight: $font-weight-400;
}
.role-name {
  font-weight: $font-weight-medium;
  font-size: 25px;
}
.align-lt {
  text-align: lefst;
}
.bold-text {
  @include fontItems($font-24, 28px, $font-weight-medium);
  text-align: center;
  color: $primary;
  padding-top: 10px;
}
.desc-text {
  padding: 5px 55px;
  @include fontItems($font-16, 19px, $font-weight-medium);
  text-align: center;
  color: $deep-gray;
}
@media screen and (max-width:320px) {
  .desc-text{
    padding:5px 20px;
  }
}
</style>
